import { NodeHtmlMarkdown } from "node-html-markdown";
import marked from "marked";

const nodeHtmlMarkdown = new NodeHtmlMarkdown();

export const convertHTMLToMarkDown = (html: string) => nodeHtmlMarkdown.translate(html || "");

export const convertMarkdownToHtml = (markdown: string, options?: marked.MarkedOptions) =>
  marked(markdown || "", options);
